import { useSelector } from 'react-redux';

// Login stores auth.userGroups as the serialized Group list: [{ id, name }]
// (see CustomLoginView / GroupSerializer on the backend). Normalize that into a
// plain array of group-name strings, defending against a JSON string or an
// array of bare names just in case of older persisted state.
export const normalizeGroupNames = (raw) => {
  let groups = raw;
  if (typeof groups === 'string') {
    try {
      groups = JSON.parse(groups);
    } catch {
      return [];
    }
  }
  if (!Array.isArray(groups)) return [];
  return groups
    .map((group) => (typeof group === 'string' ? group : group?.name))
    .filter(Boolean);
};

// Returns true if the current user belongs to (at least one of) `required`.
// `required` may be a single group name or an array of names. Matching is
// case-insensitive. Superusers always pass, mirroring the backend
// HasGroupPermission staff/superuser bypass.
export const useHasGroup = (required) => {
  const isSuperUser = useSelector((state) => state.auth.isSuperUser);
  const rawGroups = useSelector((state) => state.auth.userGroups);

  if (isSuperUser) return true;

  const names = normalizeGroupNames(rawGroups).map((name) => name.toLowerCase());
  const requiredList = (Array.isArray(required) ? required : [required])
    .filter(Boolean)
    .map((group) => group.toLowerCase());
  return requiredList.some((group) => names.includes(group));
};
